import { UserLayout } from "@/src/layouts/UserLayout";
import { Card } from "@/src/components";
import { Balance, Boosts, HarvestButton, PendingRewards, HarvestInfo, Stake } from "@/src/views/home";

export const Farms = () => {
  return (
    <UserLayout>
      <div className="max-w-5xl w-full mx-auto p-4 sm:p-5 lg:p-8 space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Balance />
          <Boosts />
          <HarvestInfo />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-2 order-2 lg:order-1">
            <Card className="h-full">
              <Stake />
            </Card>
          </div>
          <div className="space-y-4 order-1 lg:order-2">
            <HarvestButton />
            <PendingRewards />
          </div>
        </div>
      </div>
    </UserLayout>
  );
};
